import { configureStore } from '@reduxjs/toolkit';
import internshipReducer from './InternshipPublicSlice';
import coursesPublicSlice from './CoursesPublicSlice';
import authReducer from './AuthSlice'

export const store = configureStore({
    reducer: {
            auth: authReducer,
        internshipsListPublic: internshipReducer,
        coursesListPublic:coursesPublicSlice,
    },
});
